import React, { ReactNode, useState } from 'react';
import AuthGuard from './AuthGuard';
import { User } from '../../services/authService';

interface ProtectedRouteProps {
  children: ReactNode;
  requireAuth?: boolean;
  title?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireAuth = true,
  title = "Welcome to LifeOS"
}) => {
  const [showAuthModal, setShowAuthModal] = useState(false);

  const handleAuthChange = (user: User | null, token?: string) => {
    console.log('ProtectedRoute: Auth change handled:', user?.id);
  };

  return (
    <AuthGuard
      requireAuth={requireAuth}
      showAuthModal={showAuthModal}
      onShowAuthModal={setShowAuthModal}
      onAuthChange={handleAuthChange}
      title={title}
    >
      {children}
    </AuthGuard>
  );
};

export default ProtectedRoute;
